import DynamicEntityTable from './DynamicEntityTable';
import DynamicEntityColumns from './DynamicEntityColumns';
import DynamicEntityRows from './DynamicEntityRows';

export default DynamicEntityTable;
export {
  DynamicEntityColumns,
  DynamicEntityRows
};
